import { Link } from "react-router-dom";

const DARK = "/assets/logo-dark.png";
const LIGHT = "/assets/logo-light.png";

export const Logo = ({ className = "", dark = false, size = "h-7 md:h-8" }) => (
  <Link
    to="/"
    data-testid="logo-home-link"
    className={`inline-flex items-center ${className}`}
    aria-label="House of David — Purveyors of Fine Interiors"
  >
    <img
      src={dark ? LIGHT : DARK}
      alt="House of David — Purveyors of Fine Interiors"
      className={`${size} w-auto`}
    />
  </Link>
);
